import { GzContentControlDataProtectionWebComponent } from './component/GzContentControlDataProtectionWebComponent';

export { GzContentControlDataProtectionWebComponent };
